module.exports = __webpack_public_path__ + "img/Postmodernisme_Gerd-Liv-Valla.3cce85e6.jpg";